import removeFromCart from './remove-from-cart';

// Move a cart item to the wishlist
const moveToWishlist = (lineItem, lineNum, elem) => {
  if (!window._swat || !window._swat.platform || !window._swat.addToWishList) {
    console.warn('Swat platform or addToWishList function is not available.');
    return;
  }

  if (!lineItem || !lineItem.id) {
    console.warn('Invalid line item data:', lineItem);
    return;
  }

  if (!lineNum || isNaN(lineNum)) {
    console.warn('Invalid line number:', lineNum);
    return;
  }

  if (!elem || !$(elem).length) {
    console.warn('Invalid element:', elem);
    return;
  }

  const wishlistData = window._swat.platform.transformCartItem(lineItem);
  // Bug fix in Swat with wishlistData.du:
  // International store: "https://www.astrthelabel.com/en-bz/products/petrova-satin-front-cutout-long-sleeve-mini-dress?variant=41654809854128"
  // US store: https://www.astrthelabel.com/products/lorena-strappy-back-long-sleeve-mini-dress?variant=41715473645744
  wishlistData.du = `${window.location.origin}${wishlistData.du.substr(wishlistData.du.indexOf('/products/'))}`;

  window._swat.addToWishList(wishlistData, () => {
    console.log('Item added to wishlist');
    $(elem).addClass('moved_to_wishlist').addClass('moving_to_wishlist');
    removeFromCart(lineNum);
  });
};

// Button to move a cart item to the wishlist
export default () => {
  $(document).on('click', '[data-cart-move-to-wishlist]', (e) => {
    e.preventDefault();

    const elem = e.currentTarget;
    const lineNum = $(e.currentTarget).closest('[data-cart-item]').data('line');
    let lineItem = window.ShopifyCartData.items[lineNum - 1];
    
    // Move to wishlist and remove
    if (lineItem) {
      moveToWishlist(lineItem, lineNum, elem);
      return;
    }

    $.getJSON('/cart.js', (cart, textStatus) => {
      window.ShopifyCartData = cart;
      lineItem = window.ShopifyCartData.items[lineNum - 1];
      moveToWishlist(lineItem, lineNum, elem);
    });
  });
};
